module.exports = __webpack_public_path__ + "img/body-2.a99baad6.png";